import keyNames from "../../keyName";
export const initialState = {
  [keyNames.themeMode]: "light",
  [keyNames.apiErrors]: null,
  [keyNames.extra]: null,
  [keyNames.isLoading]: "noLoading",
  [keyNames.toastData]: null,
  [keyNames.userData]: null,
  [keyNames.tataToken]: null,
  [keyNames.allEmployeesData]: null,
  [keyNames.forceLogOut]: false,
  [keyNames.registeredUserData]: null,
  [keyNames.campaignData]: null,
  [keyNames.campaignDetails]: null,
  [keyNames.campaignsOfProgramManagerData]: null,
  [keyNames.databaseUploadData]: null,
  [keyNames.programManagersData]: null,
  [keyNames.allAgentsData]: null,
  [keyNames.allocAndUnallocAgentData]: null,
  [keyNames.allNonAssignedAgentsData]: null,
  [keyNames.allAssignedAgentsData]: null,
  [keyNames.agentsProgramData]: null,
  [keyNames.campaignDatabaseData]: null,
  [keyNames.assignDatabaseToAgent]: null,
  [keyNames.callingDataById]: null,
  [keyNames.invoicesByPMAndMonth]: null,
  [keyNames.invoicesOfAgent]: null,
  [keyNames.allGenInvoicesOfPmMonthWise]: null,
  [keyNames.allAgentsReportData]: null,
  [keyNames.dashboardData]: null,
  [keyNames.hourlyAnalysisData]: null,
  [keyNames.attendanceData]: null,

  //master database
  [keyNames.allUsersMasterdbData]: null,
  [keyNames.allMasterDataWithEngagements]: null,
  [keyNames.allCompaniesDataMasterdb]: null,
  [keyNames.updateUserMasterdb]: null,
  [keyNames.addMasterDataBatch]: null,
  [keyNames.dropdownFiltersData]: null,
  [keyNames.dynamicDropdownOptions]: null,

  //presales filtered data
  [keyNames.getAllFilteredDataSummary]: null,

  //webHooks
  [keyNames.allTemplateData]: null,
  [keyNames.uploadedLinkedinProfiles]: null,
  [keyNames.allLinkedinProfilesData]: null,

  //email templates
  [keyNames.allTemplatesData]: null,
  [keyNames.sendEmailWithTemplate]: null,

  //external registrations
  [keyNames.getAllExternalRegistrations]: null,

  //magicLinks
  [keyNames.generateMagicLink]: null,
  [keyNames.filterResultsSummary]: null,

  // client match data cache
  [keyNames.allcompaniesMatchedData]: null,
  [keyNames.matchDataCampaignId]: null,
};
